export default "__VITE_ASSET__B7U9GsXR__"